import { useState } from 'react'
import { Box, Tabs, Tab, Typography } from '@mui/material'
import PropTypes from 'prop-types'
import './tabs.scss'
function CustomTabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`custom-tabpanel-${index}`}
      aria-labelledby={`custom-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  )
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
}

function CustomTabs({ tabs }) {
  const [value, setValue] = useState(0)

  const a11yProps = (index) => {
    return {
      'id': `custom-tab-${index}`,
      'aria-controls': `custom-tabpanel-${index}`,
    }
  }

  const handleChangeTabs = (event, newValue) => {
    setValue(newValue)
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChangeTabs} className='tabs' aria-label='custom tabs example'>
          {tabs.map((tab, index) => (
            <Tab key={index} label={tab.label} className='custom-tab' {...a11yProps(index)} />
          ))}
        </Tabs>
      </Box>
      {tabs.map((tab, index) => (
        <CustomTabPanel key={index} value={value} index={index}>
          {tab.tabContent}
        </CustomTabPanel>
      ))}
    </Box>
  )
}

CustomTabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      content: PropTypes.node.isRequired,
    }),
  ).isRequired,
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default CustomTabs
